<template lang="pug">
    .article-section.article-section__airplane(
        v-observe-visibility="visibilityChanged"
        )

        .airplanes-grid
            .airplanes-grid__text.airplanes-grid__text--heading(v-html='content.text[0]')
            .airplanes-grid__text.airplanes-grid__text--one(v-html='content.text[1]')
            .airplanes-grid__text.airplanes-grid__text--two(v-html='content.text[2]')
            .airplanes-grid__text.airplanes-grid__text--three(v-html='content.text[3]')
            .airplanes-grid__image.airplanes-grid__image--7000m
                img(:src='require(`@/assets/img/articles/plotkin/illustrations/${content.illustrations.images[3]}`)')
            .airplanes-grid__image.airplanes-grid__image--air-4-1
                img(:src='require(`@/assets/img/articles/plotkin/illustrations/${content.illustrations.images[0]}`)')
            .airplanes-grid__image.airplanes-grid__image--air-4-2
                img(:src='require(`@/assets/img/articles/plotkin/illustrations/${content.illustrations.images[0]}`)')
            .airplanes-grid__image.airplanes-grid__image--air-5
                img(:src='require(`@/assets/img/articles/plotkin/illustrations/${content.illustrations.images[1]}`)')
            .airplanes-grid__image.airplanes-grid__image--rule
                img(:src='require(`@/assets/img/articles/plotkin/illustrations/${content.illustrations.basic}`)')
</template>

<script>
import * as basicScroll from 'basicscroll';
export default {
    name: 'AirplanesText',
    props: {
        content: Object
    },
    methods: {
        visibilityChanged(isVisible, {target}) {
            if (isVisible) {
                this.initbasicScroll = basicScroll.create({
                    elem: target,
                    from: 'top-bottom',
                    to: 'bottom-top',
                    direct: true,
                    props: {
                        '--transform': {
                            from: 0,
                            to: 1
                        }
                    }
                });
                this.initbasicScroll.start();
            } else {
                if (this.initbasicScroll) this.initbasicScroll.destroy();
            }
        }
    }
};
</script>

<style lang="scss">
@import '@/assets/css/vars.scss';

.article-section__airplane {
    padding: 70px calc(var(--padding) * 2);

    @media (--viewport-laptop) {
        padding: 0.5em var(--padding-mobile);
    }
}

.airplanes-grid {
    display: grid;
    grid-template-columns: auto 1fr 1fr;
    grid-row-gap: 40px;
    grid-column-gap: 3vw;
    align-items: center;
    grid-template:
        'ir i7 th'
        'ir i1 t1'
        'ir i2 t2'
        'ir i3 t3';

    @media (--viewport-tablet) {
        grid-template-columns: auto 1fr;
        grid-column-gap: 2vw;
        grid-template:
            'th th'
            'ir i7'
            'ir i1'
            'ir t1'
            'ir i2'
            'ir t2'
            'ir i3'
            'ir t3';
    }

    &__text {
        // font-size: 1rem;

        &--heading {
            grid-area: th;
            border-bottom: 2px solid var(--color-red);

            p {
                margin-bottom: 40px;
            }
        }
        &--one {
            grid-area: t1;
        }
        &--two {
            grid-area: t2;
        }
        &--three {
            grid-area: t3;
        }
    }

    &__image {
        &--7000m {
            grid-area: i7;
            align-self: start;
            padding-top: 158px;
            @media (--viewport-tablet) {
                padding-top: 0;
            }
        }
        &--air-4-1 {
            grid-area: i1;
            padding: 10px 20px;
            transform: translateY(calc((0.5 - var(--transform)) * 150%));
        }
        &--air-4-2 {
            grid-area: i2;
            padding: 10px 20px;
            transform: translateY(calc((0.5 - var(--transform)) * 150%));
        }
        &--air-5 {
            grid-area: i3;
            padding: 10px 20px;
            transform: translateY(calc((0.5 - var(--transform)) * 150%));
        }
        &--rule {
            grid-area: ir;
            padding-top: 150px;
            @media (--viewport-tablet) {
                padding-top: 0;
            }

            img {
                width: 11vw;

                @media (--viewport-tablet) {
                    width: 32vw;
                    height: 290vw;
                }
            }
        }
    }
}
</style>
